import { render, staticRenderFns } from "./ManageCdss.vue?vue&type=template&id=5e88d8e6"
import script from "./ManageCdss.vue?vue&type=script&lang=js"
export * from "./ManageCdss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports